import * as runtypes from 'runtypes';

export const Environment = runtypes.Union(runtypes.Literal('development'), runtypes.Literal('production'));

export type Environment = runtypes.Static<typeof Environment>;
